import { render, staticRenderFns } from "./studyPage.vue?vue&type=template&id=ecf612c6&scoped=true&"
import script from "./studyPage.vue?vue&type=script&lang=js&"
export * from "./studyPage.vue?vue&type=script&lang=js&"
import style0 from "./studyPage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./studyPage.vue?vue&type=style&index=1&id=ecf612c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf612c6",
  null
  
)

export default component.exports